import { Box, Button } from '@mui/material';
import { common } from '@mui/material/colors';
import BaseDialog from 'common/components/base-dialog';
import React from 'react';
import { IQuestionNewEditForm } from 'types/campaign-design';
import { createStyleSheet } from 'utils/helpers';
interface ModalConfirmSwapQuestionProps {
    open: boolean;
    onClose: () => void;
    dragSource: IQuestionNewEditForm | null;
    onOk: () => void;
}
const ModalConfirmSwapQuestion: React.FC<ModalConfirmSwapQuestionProps> = ({
    open,
    onClose,
    dragSource,
    onOk,
}) => {
    return (
        <BaseDialog
            open={open}
            onClose={() => onClose()}
            title="Xác nhận di chuyển câu hỏi câu hỏi"
            fullWidth={false}
            maxWidth={false}
            sxContent={{
                width: '978px',
                padding: '45px 50px',
                textAlign: 'center',
            }}
        >
            <Box
                sx={{
                    fontSize: '18px',
                    fontWeight: '400',
                    color: common.black,
                }}
            >
                Bạn có chắc muốn di chuyển câu hỏi{' '}
                <b>{`"${dragSource?.question}"`}</b> này không? <br /> Lưu ý:
                Nếu bạn xác nhận di chuyển câu hỏi thì tất cả các logic của bộ
                câu hỏi sẽ không còn hiệu lực?
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 1,
                    mt: 5,
                }}
            >
                <Button
                    type="submit"
                    variant="outlined"
                    sx={{
                        ...styles.modalButton,
                        borderWidth: '2px',
                    }}
                    onClick={() => {
                        onClose();
                    }}
                >
                    Đóng
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    sx={styles.modalButton}
                    onClick={onOk}
                >
                    Đồng ý
                </Button>
            </Box>
        </BaseDialog>
    );
};
const styles = createStyleSheet({
    modalButton: {
        textTransform: 'none',
        borderRadius: '60px',
        minHeight: '60px',
        minWidth: '155px',
        fontSize: '20px',
        fontWeight: '700',
    },
});
export default ModalConfirmSwapQuestion;
